var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsersPlusinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 29 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.568 6.5V5.334a1.18 1.18 0 00-1.185-1.167 1.18 1.18 0 00-1.185 1.167V6.5h-1.185a1.18 1.18 0 00-1.185 1.167 1.18 1.18 0 001.185 1.167h1.185V10a1.18 1.18 0 001.185 1.167A1.18 1.18 0 0026.568 10V8.834h1.185a1.18 1.18 0 001.184-1.167A1.18 1.18 0 0027.753 6.5h-1.185zM9.98 10c2.618 0 4.739-2.088 4.739-4.666 0-2.579-2.121-4.667-4.74-4.667-2.618 0-4.74 2.088-4.74 4.667C5.24 7.912 7.362 10 9.98 10zM9.98 11.167C6.814 11.167.5 12.73.5 15.834v3.5h18.958v-3.5c0-3.104-6.315-4.667-9.479-4.667zM15.323.726c1.09 1.236 1.765 2.846 1.765 4.608 0 1.762-.675 3.372-1.765 4.608 2.322-.291 4.135-2.228 4.135-4.608 0-2.38-1.813-4.317-4.135-4.608zM20.086 12.136c1.055.968 1.742 2.181 1.742 3.698v3.5h2.37v-3.5c0-1.692-1.884-2.928-4.112-3.698z",
    fill: "inherit"
  })));
}

export default SvgUsersPlusinline;